import React from 'react';

export const VehicleBuddyLogo = ({ className = "h-8 w-8", showText = true, variant = "default" }) => {
  // VB monogram forming road + shield concept
  const colors = {
    default: {
      primary: "hsl(204 80% 28%)", // navy
      accent: "hsl(174 45% 50%)"   // sea-glass
    },
    white: {
      primary: "#FFFFFF",
      accent: "#FFFFFF"
    },
    dark: {
      primary: "hsl(204 80% 44%)",
      accent: "hsl(174 45% 60%)"
    }
  };

  const color = colors[variant] || colors.default;

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      {/* VB Icon - Forms a subtle road/shield */}
      <svg
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="h-8 w-8"
        aria-label="VehicleBuddy Logo"
      >
        {/* Shield outline */}
        <path
          d="M24 4L8 12V22C8 32 16 40 24 44C32 40 40 32 40 22V12L24 4Z"
          fill={color.primary}
          opacity="0.1"
        />
        <path
          d="M24 4L8 12V22C8 32 16 40 24 44C32 40 40 32 40 22V12L24 4Z"
          stroke={color.primary}
          strokeWidth="2"
          strokeLinejoin="round"
        />
        
        {/* V shape (forms road perspective) */}
        <path
          d="M14 14L24 32L34 14"
          stroke={color.accent}
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        
        {/* B curve */}
        <path
          d="M26 18H32C32 18 34 18 34 20C34 22 32 22 32 22M26 22H32C32 22 34 22 34 24C34 26 32 26 32 26H26"
          stroke={color.primary}
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        
        {/* Center accent dot */}
        <circle cx="24" cy="24" r="1.5" fill={color.accent} />
      </svg>
      
      {showText && (
        <span className="font-semibold text-xl tracking-tight" style={{ fontFamily: 'Space Grotesk' }}>
          VehicleBuddy
        </span>
      )}
    </div>
  );
};

// Simplified icon-only version for mobile/favicon
export const VehicleBuddyIcon = ({ className = "h-6 w-6", variant = "default" }) => {
  const colors = {
    default: {
      primary: "hsl(204 80% 28%)",
      accent: "hsl(174 45% 50%)"
    },
    white: {
      primary: "#FFFFFF",
      accent: "#E0F2F1"
    },
    dark: {
      primary: "hsl(204 80% 44%)",
      accent: "hsl(174 45% 60%)"
    }
  };

  const color = colors[variant] || colors.default;

  return (
    <svg
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label="VehicleBuddy"
    >
      <path
        d="M24 4L8 12V22C8 32 16 40 24 44C32 40 40 32 40 22V12L24 4Z"
        fill={color.primary}
      />
      <path
        d="M14 14L24 32L34 14"
        stroke={color.accent}
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="24" cy="24" r="1.5" fill={color.accent} />
    </svg>
  );
};

export default VehicleBuddyLogo;
